
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, useState } from "react";
import Select from "react-select";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'


// ../../../../images/candidate/upload.png
//  download fill

import Upload from "../../../../images/candidate/upload.svg";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Button,
    Form,
    Input,
    UncontrolledTooltip,
} from "reactstrap";

import pdf from "../../images/document.svg";
import request, { NodeURL } from "../../../../api/api";
import { useProfilecontext } from "../Editprofileprovider";
import { useFieldArray, useForm } from "react-hook-form";
import { initailState } from "../utils/profileReducer";
import { DateInput } from "./UserInputs";
import { toast } from "react-toastify";
import { isValidDate , createFormData ,scroll_to_top, IsArray} from "../../../common/utils";
import moment from "moment";
import { ImageViewModel } from "./ImageViewModel";






const addfileToServer = async (file = {}) => {
    try {
        const res = await request({ url: "/candidate/form/addFilestoLocalDB", method: "POST", data: file, })
        return res.file_path ? res.file_path : ''
    } catch (error) {
        return error;
    }
}





// file upload for /employees/apply-online-form/save-files
/*

filefor: dbs || driving
uploadfiles: (binary)
educationCourse: undefined
educationCourseID: undefined
*/


/*
file delete

employees/apply-online-form/delete-files

{
    "filefor": "driving", || dbs
    "fileid": "651fb1e1966dd96ff4079bc5",
    "filepath": "uploads/images/employee/1696575969264.png"
}





*/

export default function DocumentTab({ isactivetab = () => { }, ...restprops } = initailState) {


    const [state, dispatch] = useProfilecontext();
    const { activeTab = {} , other_documents = [] , updateForm=()=>{}} = state;


    const intialOtherDocument = {
        "document_title": "",
        "document_expiry": false,
        "document_expiry_date": new Date(),
        "upload_doc": ""
    };
    const { control, register, getValues, watch, handleSubmit, setValue , formState} = useForm({
        values: {
            other_documents: other_documents
        }
    });
    const { fields, append, remove } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "other_documents", // unique name for your Field Array

    });

    
    const initialViewer = {
        viewUrl:"",
        isPreview:false
    }
    const [Viewer , setViewer]  = useState(initialViewer)

    const toggleImageViewer = (url = '') =>{
        url = String(url).startsWith('uploads/images') ? `${NodeURL}/${url}` : ''
        setViewer((prev)=>({...prev , viewUrl:url, isPreview:!prev.isPreview}))
    }


    
    const toggleTab = (tab = '', tabId = '') => {
        dispatch({ type: "TOGGLE_TAB", payload: { tab, tabId } })
        scroll_to_top()
    }



    const handleSetToast = (id = '', message = '', type = '') => {
        dispatch({ type: "SET_TOAST", payload: { id, message, type } })
    }


	const handleOnDateChange = (e ='' ,name='') => {
        let _date = isValidDate(e) ? moment(e): '';
        isValidDate(e) &&  setValue(name,_date , {shouldDirty:true})
    }

    // ["pdf" , "png" ,"jpeg" ,"jpg"].includes(temp1.type))slice('dddddimage/png'.search("/"))
    const handleOnFilesChange = async (e = {} ,name = '') =>{
        let files = (e && e.target && e.target.files) ? e.target.files : [];
            files = files.length ? files[0] : null;

        if(!files) return;
        if(!(files.size < 5242880)){
            return toast.error("Maximum upload size is 5MB");
        }
        if(!["pdf" , "png" ,"jpeg" ,"jpg"].includes(files.type.slice(files.type.search("/") + 1))){
            return toast.error("File Format not supported");
        }
            let data = createFormData({upload_doc : files})
            let url = await addfileToServer(data);
            url && setValue(name , url);
            toast.success("File Uploaded!" , {autoClose:2000})

    }

    const handlOnappend = ()=>{
        append(intialOtherDocument)
    }
    const handleOnRemove = (index) =>{
        remove(index);
    }

    const handleOnDeleteFile = (name = '' ) =>{
        setValue(name ,'' ,{ shouldDirty:true });
        toast.success("File Removed" , {autoClose:2000})
    }


    const onFormSubmit = (data = {}) => {
        let other_documents = JSON.stringify(IsArray(data.other_documents)? data.other_documents : []);
        if (updateForm) {
            updateForm({ other_documents, setctionId: "documents" }).then((res={}) => {
                // if(res.result && res.result.work_experience && IsArray(res.result.work_experience)){ }
                handleSetToast && handleSetToast("formupdate", "saved!", "success")
            })
        }
    }

    const handleOnContinue = async () =>{
        if(formState.isDirty){
            onFormSubmit(getValues())
        }
            toggleTab("menu" , "3")
	}



    return (
        <>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="emp_edu">
                    <div className="emp_heading">
                        <h6 className="mt-0 ">OTHER DOCUMENTS</h6>
                        <p>Please upload any other documents that are not listed above but are important to support your application.</p>
                    </div>
                    {/* <p className="p-3 title_sub">Please add and upload certificates of your qualifications.</p> */}
                    {
                        getValues("other_documents").length > 0
                            ? <div className="position-relative col-12 col-md-12">
                                <div className="new-table hiding-calendar">
                                    <table className="table">
                                        <tr>
                                            <th className="col-lg-4">
                                                Document Title/Name
                                            </th>
                                            <th className="col-lg-4">Is there an expiry date?</th>
                                            <th className="col-lg-3">Upload </th>
                                            <th className="col-lg-1"></th>
                                        </tr>
                                        {
                                            fields.map((other_doc={}, index)=>{
                                                return                                     <tr>
                                                <td>
                                                    <div className="form-group">
                                                        <input type="text" placeholder="Document Title/Name" className="form-control" {...register(`other_documents.${index}.document_title`)}/>
                                                    </div>
                                                </td>
        
                                                <td>
                                                    <div className="renewal_sec">
                                                        <div className="col-lg-1 form-group">
                                                            <input type="checkbox"  {...register(`other_documents.${index}.document_expiry`)} />
                                                        </div>
                                                        {
                                                            watch(`other_documents.${index}.document_expiry`) &&
                                                            <DateInput 
                                                              parentClassName="col-md-11" 
                                                              name={`other_documents.${index}.document_expiry_date`} 
                                                              handleOnDateChange={handleOnDateChange} 
                                                              value={ watch(`other_documents.${index}.document_expiry_date`)}
                                                              placeholder="Expiry Date"
                                                            />
                                                        }

                                                    </div>
                                                </td>
                                                <td>
                                                    {
                                                        !Boolean(watch(`other_documents.${index}.upload_doc`))
                                                            ? <div className="up_img" style={{ textAlign: "left" }}>
                                                                <label>
                                                                <img src={Upload} alt="other_documentss" />
                                                                <input className="d-none" type="file"  accept="application/pdf,.pdf,image/*" onChange={(e)=>handleOnFilesChange(e ,`other_documents.${index}.upload_doc`)}  />
                                                                </label>
                                                            </div>
                                                            : <FileViewOtherDoc url={watch(`other_documents.${index}.upload_doc`)} onClick={(url)=>toggleImageViewer(url)} onDelete={(url)=>handleOnDeleteFile(`other_documents.${index}.upload_doc`,url )} />
                                                    }

                                                </td>
                                                <td>
                                                    <Button className="table-close"  type="button"  onClick={()=>handleOnRemove(index)}>x</Button>
                                                </td>
                                            </tr>
                                            })
                                        }
                                    </table>
                                </div>
                            </div>
                            : <></>
                    }
                    <div className="position-relative col-12 col-md-12">
                        <Button className="add-row" type="button"  onClick={handlOnappend} >+</Button>
                    </div>

                    <hr style={{ width: "100%" }} />

                    <div className="position-relative col-12 col-md-12">
                        <div className="mt-0 text-center three_button" id="s-c-buttons">
                            <Button type="button" onClick={()=>toggleTab("menu" , '1')}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button>
                            <Button  className={`btn-save ${formState.isDirty ? "" : "cursor-no-drop"}`} disabled={!formState.isDirty} >Save</Button>
                            <Button type="button" onClick={handleOnContinue}>Continue</Button>
                        </div>
                    </div>

                </div>
            </Form>
            <ImageViewModel filepath={Viewer.viewUrl} isOpen={Viewer.isPreview} toggle={toggleImageViewer} />
        </>
    )
}



const FileViewOtherDoc = ({ url = '', onClick = () => { }, onDelete = () => { } }) => {
    let id = url.replace(/[\/.]/g ,"-")
    return (
        url
        ? <div className="up_imgs">
            <img id={id} src={pdf} alt="Image_viewer" className="cursor-pointer" onClick={()=>onClick(url)} />
            <button type="button" onClick={()=>onDelete(url)} className="trash-bttn"><i className="fa fa-trash-o cursor-pointer" aria-hidden="true"></i></button>
            <UncontrolledTooltip placement="bottom" target={id}>View Document</UncontrolledTooltip>
          </div>
        : null
    )
}